module.exports = __webpack_public_path__ + "static/img/rain.c5971bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/rain.png
// module id = J4mW
// module chunks = 1